export default __webpack_public_path__ + "static/media/gu.70a58382.svg";